<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper confirmAction" style="z-index: 5000; opacity: 1;">
			<div class="modal small confirmAction" ng-class="{inWindowPopupOpened: inWindowPopupOpened}">
				<!-- ngIf: ::w.params.modalParams.backgroundFlare -->
				<div class="modalContent" ng-style="{minHeight: w.getOverlayHeightWithPadding(-10) || 'none'}">
					<div class="functionPanel">
						<a ng-if="w.params.modalParams.closeable" clickable="closeWindow('confirmAction')" class="closeWindow clickable"  play-on-click="7" @click="onModalClose(close)" content="Закрыть" v-tippy="{placement: 'bottom'}">
							<i class="closeWindow" :class="{'action_cancel_small_flat_black': !cancelHover, 'action_cancel_small_flat_green': cancelHover}" @mouseover="cancelHover = true" @mouseleave="cancelHover = false"></i>
						</a>
					</div>
					<div class="contentHeader">
						<h2 ng-if="!w.contentHeaderText" ng-class="::{static: w.params.modalParams.staticPosition}" class="static">
							<span translate="" data="" options="ConfirmAction.Title"><span>Ты уверен?</span></span>
						</h2>
						<!-- ngIf: w.contentHeaderText -->
					</div>
					<div class="confirmActionContent" ng-controller="confirmActionCtrl">
						<i ng-if="::featureClass" class="featureIcon unit_population_medium_illu"></i>
						<div ng-include="" ng-if="::customContent && action == 'population'" src="'tpl/mainlayout/partials/populationWarning.html'">
							<div class="populationWarning">
								<h1 ng-if="::action" translate="" data="limit:200"><span>Данное действие приведет к увеличению населения до 200 жителей.</span></h1>
								<!-- ngIf: ::!action -->
								<!-- ngIf: ::action && settlersOnTheWay -->
								<div class="effects" translate=""><span>Это означает:</span></div>
								<div class="effectsList">
									<div class="effect" ng-if="::player.data.hasNoobProtection" translate=""><span>защита новичка закончится;</span></div>
									<div class="effect" translate=""><span>вы не сможете переместить деревню.</span></div>
								</div>
							</div>
						</div>
						<!-- ngIf: ::customContent && action == 'settle' -->
						<!-- ngIf: ::!customContent -->
						<label class="clickInputLabel">
							<div class="clickInputWrapper">
								<input type="checkbox" ng-model="doNotShowAgain" class="ng-pristine ng-untouched ng-valid" />
								<i class="action_check_tiny_flat_black"></i>
							</div>
							<span translate=""><span>Больше не показывать данное сообщение</span></span>
						</label>
						<div class="horizontalLine"></div>
						<div class="buttons">
							<button class="cancel clickable" clickable="confirm(false)" @click="onModalClose(close)">
								<div class="content">
									<span ng-transclude="" class="innerText">
										<span translate=""><span>Отмена</span></span>
									</span>
									<!-- ngIf: price > 0 || forceGoldUsage -->
									<!-- ngIf: price == -1 && !forceGoldUsage -->
									<div class="animationOverlay"></div>
									<i class="checkmark action_check_small_flat_white"></i>
									<i class="checkmark action_check_small_flat_black"></i>
									<i class="checkmark action_check_small_flat_red"></i>
								</div>
							</button>
							<button clickable="confirm(true)" class="clickable" @click="onModalClose(close)">
								<div class="content">
									<span ng-transclude="" class="innerText">
										<span translate=""><span>Подтвердить</span></span>
									</span>
									<!-- ngIf: price > 0 || forceGoldUsage -->
									<!-- ngIf: price == -1 && !forceGoldUsage -->
									<div class="animationOverlay"></div>
									<i class="checkmark action_check_small_flat_white"></i>
									<i class="checkmark action_check_small_flat_black"></i>
									<i class="checkmark action_check_small_flat_red"></i>
								</div>
							</button>
						</div>
					</div>
					<div class="window-overlay" name="smallOverlay"></div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>